"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnsurePackageUnderstandingPlanResultSchema = exports.EnsurePackageUnderstandingPlanStatus = exports.EnsurePackageUnderstandingPlanInputSchema = void 0;
const zod_1 = require("zod");
exports.EnsurePackageUnderstandingPlanInputSchema = zod_1.z.object({
    packageId: zod_1.z.string(),
    generatorName: zod_1.z.string(),
    priority: zod_1.z.number().int().min(0).optional(),
});
var EnsurePackageUnderstandingPlanStatus;
(function (EnsurePackageUnderstandingPlanStatus) {
    EnsurePackageUnderstandingPlanStatus["Created"] = "created";
    EnsurePackageUnderstandingPlanStatus["SkippedExisting"] = "skipped-existing";
    EnsurePackageUnderstandingPlanStatus["SkippedOwned"] = "skipped-owned";
    EnsurePackageUnderstandingPlanStatus["Failed"] = "failed";
})(EnsurePackageUnderstandingPlanStatus || (exports.EnsurePackageUnderstandingPlanStatus = EnsurePackageUnderstandingPlanStatus = {}));
exports.EnsurePackageUnderstandingPlanResultSchema = zod_1.z.object({
    planId: zod_1.z.string().nullable(),
    status: zod_1.z.nativeEnum(EnsurePackageUnderstandingPlanStatus),
    errorMessage: zod_1.z.string().optional(),
    retryable: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=wizard-plan-activities.types.js.map